function SmsDashboardReducer(state, action) {

  switch (action.type) {
    case "set_current_text_message_thread":
      return {
        ...state,
        text_message_thread: action.text_message_thread
      };
    case "set_text_message_threads":
      return {
        ...state,
        text_message_threads: action.text_message_threads,
        settings: action.settings
      };
  }

}
export default SmsDashboardReducer;
